import { FunctionComponent } from "react";

interface HomeProps {
  isLoggedIn: boolean;
}

const Home: FunctionComponent<HomeProps> = ({ isLoggedIn }) => {
  return (
    <>
      {/* Main content area */}
      <div className="container mt-5">
        <div className="row">
          <div className="col-12 text-center">
            {isLoggedIn ? (
              <div>
                <h1>Welcome to UAV Trade Zone</h1>
                <p className="lead">Your one-stop shop for UAV products and services.</p>
              </div>
            ) : (
              <div>
                <h1>Welcome to UAV Trade Zone</h1>
                <p className="lead">Your one-stop shop for UAV products and services.</p>
                <p>Please login or sign up to get started.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
